import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { Alert } from 'ui'
import { closeModal } from 'store/actions/modals'

import { t } from 'translations'

const UnreadBulletinModal = ({ unreadBulletinCount }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const goToMessages = () => {
    history.push('/my/messages')
    dispatch(closeModal())
  }
  return (
    <BaseModal hideButtons title="employee.myHome.NEWBULLETIN_MODAL">
      <Alert variant="warning" className="mb-2">
        {t('employee.myHome.BULLETIN_ALERT', { unreadBulletinCount })}
      </Alert>
      <div className="mt-2">
        <Button className="btn btn-primary mr-2" text="employee.myHome.VIEW_MY_MESSAGES" onClick={() => goToMessages()} />
        <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
          {t(`actions.CLOSE`)}
        </Button>
      </div>
    </BaseModal>
  )
}

export default UnreadBulletinModal
